module.exports = __webpack_public_path__ + "static/Srinivasa-2-ed3e3666116f70c7c9a1cc48b2380af2.jpeg";